import { PlaylistsListItem } from 'types/playlists.types';
import { Audio } from 'types/audio';
import { SelectedAudioObject } from 'app/components/Audio';

export const getSuccessMessage = (playlists: PlaylistsListItem[]) => {
  if (playlists.length === 1) {
    return `Audio file added to ${playlists[0].title}`;
  }
  return `Audio file added to ${playlists.length} playlists`;
};

export const getFailureMessage = (failedCount: number, totalCount: number) => {
  if (failedCount === totalCount) {
    return `Audio file${totalCount > 1 ? 's' : ''} not added, please try again`;
  }

  return `Failed to add ${failedCount}/${totalCount} audio${
    failedCount > 1 ? 's' : ''
  }, please try again`;
};

export const audioToSelectedAudioObject: (
  audio: Audio
) => SelectedAudioObject = (audio) => ({
  [audio.guid]: {
    audioTitle: audio.title,
    audioGuid: audio.guid,
    songTitle: audio.songTitle || '',
    songGuid: audio.parent,
    type: audio.type,
  },
});
